export class Colors {
    static Black = "#000000";
    static Brown = "#272727";
}